import { Region } from "resource-planner-model";

export const FETCH_REGIONS = "regions/fetch";
export const LOAD_REGIONS = "regions/load";
export const REMOVE_REGION = "regions/remove";
export const REMOVE_REGION_LOCAL = "regions/remove_local";
export const PERSIST_REGION = "regions/persist";
export const UPSERT_REGION = "regions/upsert";

export interface RegionsState {
  items: { [id: string]: Region };
  loadedAll: boolean;
  nextToken?: string;
  synching: boolean;
}

export interface FetchRegionsAction {
  type: typeof FETCH_REGIONS;
  append?: boolean;
  limit?: number;
  nextToken?: string;
  paginated?: boolean;
}

export interface LoadRegionsAction {
  type: typeof LOAD_REGIONS;
  append?: boolean;
  items: Region[];
  loadedAll?: boolean;
  nextToken?: string;
}

export interface RemoveRegionAction {
  type: typeof REMOVE_REGION;
  id: string;
}

export interface RemoveRegionLocalAction {
  type: typeof REMOVE_REGION_LOCAL;
  id: string;
}

export interface PersistRegionAction {
  type: typeof PERSIST_REGION;
  item: Region;
}

export interface UpsertRegionAction {
  type: typeof UPSERT_REGION;
  item: Region;
}

export type RegionAction =
  | FetchRegionsAction
  | LoadRegionsAction
  | RemoveRegionLocalAction
  | RemoveRegionAction
  | PersistRegionAction
  | UpsertRegionAction;
